<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import { progettoAzioniDtoFields, progettoAzioniGeneralDtoFields } from "../../utils/TableFields/project-action-dto.fields";
  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";

  $: tableFields = [...progettoAzioniGeneralDtoFields, ...progettoAzioniDtoFields];

  let cancreate : boolean = PermissionService.isAllowedTo($user, 'companies.cancreate');
  let candelete : boolean = PermissionService.isAllowedTo($user, 'companies.candelete');
  let canedit : boolean = PermissionService.isAllowedTo($user, 'companies.canedit');

 
  enum ProjectActionPage {
    List = 1,
    GANTT
  }
 

  let currentTab: ProjectActionPage = ProjectActionPage.List;


  import {
    filter,
    loading,
    pagination,
    initList,
    onPageChange,
    search,
    clearSearch,
    tasks,
    recordsActions, onExportProjectActions, onEdit
  } from "./project-actions.store";
import FormField from "../../components/Form/FormField.svelte"; 
import Icon from "../../components/Icon.svelte";
import Button from "../../components/Button.svelte";
    import DateInput from "../../components/Form/Fields/DateInput.svelte";
    import ProjectStatesDropdown from "../../components/Business/ProjectStatesDropdown.svelte";
    import Tabs from "../../components/Tab/Tabs.svelte";
    import Tab from "../../components/Tab/Tab.svelte";
    import Gantt from "../../components/Business/Gantt.svelte";
  import {onExportProjects} from "./project.store";

  
    onMount(() => {
      initList();
      let client_size = window.outerWidth - (window.outerWidth <1600?310:400);
      window.document.getElementById("tab_container").style.width = client_size + "px";
    });

</script>

<SearchHeader
entitySingular={'azione progetto'}
entityPlural={'azioni progetto'}
numRecords={$pagination != null ? $pagination.totalRecords : 0}
bind:searchValue={$filter.criteria.query}
on:search={search}
>
<div slot="search" class="level">
 


<div class="level-item" >
  <div>
    <FormField>
      <DateInput
        name=""
        placeholder="Data Inizio"
        required={false}
        bind:value={$filter.criteria.dataFrom} 
      />
    </FormField>        
  </div>
</div>

<div class="level-item" >
  <div>
    <FormField>
      <DateInput
        name=""
        placeholder="Data Fine"
        required={false}
        bind:value={$filter.criteria.dataTo} 
      />
    </FormField>         
  </div>
</div>

<div class="level-item" >
  <div>        
    <FormField>
      <ProjectStatesDropdown
        name=""
        placeholder="Filtra per stato..."
        required={false}
        bind:value={$filter.criteria.stato} 
        on:select={search}        
      />
    </FormField>
  </div>
</div>

<div class="level-item">
  <p class="control">
    <Button on:click={search}>
      <Icon name="search" />

      <span> Cerca </span>
    </Button>
  </p>
</div>

<div class="level-item">
  <p class="control">
    <Button on:click={clearSearch}>Azzera</Button>
  </p>
</div> 

</div>
</SearchHeader>

<div id="tab_container" style="width: 1000px;overflow-x: scroll;" >
  <Tabs>
    <Tab
      label="Lista azioni"
      active={currentTab == ProjectActionPage.List}
      on:click={(_) => {
        currentTab = ProjectActionPage.List;
        let client_size = window.document.getElementsByClassName("main-layout-content")[0].offsetWidth - 60;
        window.document.getElementById("tab_container").style.overflowX = 'scroll';
      }}
    />
    <Tab
        label="GANTT azioni"
        active={currentTab == ProjectActionPage.GANTT}
        on:click={(_) => {
          currentTab = ProjectActionPage.GANTT;
          let client_size = window.document.getElementsByClassName("main-layout-content")[0].offsetWidth - 60;
          window.document.getElementById("tab_container").style.overflowX = 'hidden';
        }}        
      /> 
  </Tabs>

      {#if currentTab == ProjectActionPage.List}
        <Table
          loading={$loading}
          fields={tableFields}
          records={$recordsActions}
          pagination={$pagination}
          createEnabled={cancreate}
          editEnabled={false}
          showEnabled={false}
          exportEnabled={true}
          deleteEnabled={candelete} 
          on:pageChange={(e) => onPageChange(e.detail)}
          on:export={(e) => onExportProjectActions()}
          on:edit={(e) => onEdit(e.detail)}
        />    
    {/if}
 
    {#if (currentTab == ProjectActionPage.GANTT)}
      {#if ($tasks.length > 0)}      
          <Gantt tasks={$tasks}  />      
      {:else}
          <div class="notification is-info"> 
            Non sono presenti azioni con almeno la <strong>data di inizio impostata</strong>, non è possibile generare un grafico GANTT
          </div>
      {/if}    
    {/if}
</div>


  
